<template>
  <div >
    <div class="body">
      <van-form @submit="submitComfirm">
        <div class="item" v-for="(item,index) in quiz" :key="index">
          <p class="question"> {{ `${index+1}、` }}{{ item.q }}</p>
          <van-field v-if="index < 6" required :name="`q${index+1}`" label="" :disabled="disabled" :rules="[{ required: true, message: '请选择' }]">
            <template #input>
              <van-radio-group :disabled="disabled" v-model="form[`q${index+1}`]" >
                <van-radio class="option" v-for="(o,i) in item.o" :name="`${i+1}`" :key="i">{{ o }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-else :name="`q${index+1}`" :disabled="disabled" label="">
            <template #input>
              <van-checkbox-group @change="(event) =>{selectOption(event,index)}" :disabled="disabled" v-model="form[`q${index+1}`]">
                <van-checkbox label-disabled class="option" v-for="(o,i) in item.o" :name="`${i+1}`" :key="i" shape="square">{{ o }}
                  <van-field name="other7" class="option-other" v-if="(index == 6 && i == 12)" v-model="form.other7" label="" placeholder="请注明" />
                  <van-field name="other8" class="option-other" v-if="(index == 7 && i == 6)" v-model="form.other8" label="" placeholder="请注明" />
                  <van-field name="other9" class="option-other" v-if="(index == 8 && i == 5)" v-model="form.other9" label="" placeholder="请注明" />
                </van-checkbox>
                
              </van-checkbox-group>
            </template>
          </van-field>
        </div>
        <div style="margin: 16px;padding-bottom: 2rem;" >
          <van-button round :disabled="disabled" block type="info" native-type="submit">{{ submitting ? '正在提交...': '提交' }}</van-button>
        </div>
      </van-form>
      
    </div>
  </div>
</template>
<script>

import axios from 'axios'
// import Compressor from 'compressorjs'
import { util,mc } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()
const quizList = `您觉得本地的食品药品安全状况如何？1、好;2、较好;3、不太好;4、不好
您觉得本地的生产安全状况如何？1、好;2、较好;3、不太好;4、不好
您觉得本地的生态环境状况如何？1、好;2、较好;3、不太好;4、不好
您觉得本地的总体安全感如何？1、好;2、较好;3、不太好;4、不好
您觉得本地的社会治安状况如何？1、好;2、较好;3、不太好;4、不好
您平时参与平安建设的频率如何？1、经常参加;2、定期参加;3、偶尔参加;4、不参加
您知道以下哪些属于电信网络诈骗？1、公检法电话要求转账;2、网上兼职刷单;3、直播间炒股;4、交友婚恋为由参与虚拟货币投资;5、网络贷款;6、网络赌博;7、退款、退费、退税，要求先付保证金;8、被拉进QQ工作群，群里公司老板着急要求转账;9、微信上自称领导要求代为转账;10、免费领取游戏皮肤和福利;11、利用赌博游戏漏洞赚钱;12、以注销贷款记录为由要求登录借贷平台或者下载贷款APP进行操作;13、其他;14、不知道
今年以来，您所在地区的网格员(工作人员)或单位是否向您宣传过以下内容？1、《浙江省平安建设条例》;2、反诈骗知识;3、反邪教知识;4、电动自行车规范停放充电;5、遵守交通规则及佩戴头盔;6、流动人口登记;7、其他;8、无（提醒用电、用气、用水安全等算哦）
您参与过哪些平安建设活动？1、参与过矛盾纠纷调解、平安巡防、安全检查、维持公共秩序等志愿活动;2、参与过消防演习、应急演练;3、参与过禁毒、禁赌、扫黄;4、制止或报告违法犯罪行为及公共安全问题(如:消防、交通、食品药品、生态环境、市政设施安全等);5、参与过平安宣传资料发放、平安建设问卷调查等;6、其他;7、没有参加（参与平安农场打卡也算哦）
您认为以下哪些是邪教？1、法轮功;2、基督教;3、全能神;4、伊斯兰教;5、佛教;6、呼喊派`.split('\n').map(item => {
  item = item.split('？')
  let quizItem = {
    q: item[0],
    o: item[1].split(';')
  }
  return quizItem
})

export default {
  name: 'SafeSxForm',
  props: {
  },
  data () {
    return {
      fid: null,
      quiz: quizList,
      form:{
        q1:'',
        q2:'',
        q3:'',
        q4:'',
        q5: '',
        q6:'',
        q7:[],
        q8:[],
        q9:[],
        q10: [],
        other7: '',
        other8:'',
        other9: '',
      },
      renovationType: 0,
      renovationStatus: 0,
      submitting: false,
      disabled: false,
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created: function () {
    if (!mc.isClient()) {
      this.$toast('请在客户端参与活动')
    } else {
      this.fid = this.$route.params.fid ? this.$route.params.fid : 13
    }
    
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    // console.log(vConsole);
  },
  methods: {
    onSelectBirthday(date) {
      this.form.birthday = date.toLocaleString().split(' ')[0]
      this.showPicker = false
    },
    priceValidate (val) {
      return val >= 50000
    },
    subdistrictConfirm(value) {
      this.form.subdistrict = value
      this.showSubdistrictPicker = false
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    preview(img) {
      ImagePreview([img])
    },
    submitComfirm(values) {
      this.$dialog.confirm({
        title: '确认提交',
      }).then(() => {
        this.onSubmit(values)
      })
    },
    selectOption(selectOption,index) {   
      var len = selectOption.length         
      if (index == 6 && len > 1 && selectOption.includes('14')) {
        this.form.q7 = (selectOption[len-1] == '14') ? ['14'] : selectOption.filter(e => {
          return e != '14'
        })
      } else if (index == 7 && len > 1 && selectOption.includes('8')) {
        this.form.q8 = (selectOption[len-1] == '8') ? ['8'] : selectOption.filter(e => {
          return e != '8'
        })
      } else if (index == 8 && len > 1 && selectOption.includes('7')) {
        this.form.q9 = (selectOption[len-1] == '7') ? ['7'] : selectOption.filter(e => {
          return e != '7'
        })
      }
    },
    onSubmit(values) {
      
      if (this.submitting) {
        return
      }

      util.Arequest((data) => {
        this.disabled = true
        this.submitting = true
        values.q7 = values.q7.join(',')
        values.q8 = values.q8.join(',')
        values.q9 = values.q9.join(',')
        values.q10 = values.q10.join(',')
        values.token = data.token
        values.userid = data.userid
        axios.post(`/encrypt3/form/safe/submit?fid=${this.fid}`,values).then(res => {
            if (res.data.msg == 'ok') {
              this.$toast('提交成功')
              this.submitBtnText = '提交成功'
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else if (res.data.msg == 'exists') {
              this.$toast('用户已有提交\n无法再次提交')
              this.submitBtnText = '已有提交，无法再次提交'
            } else if (res.data.msg == 'no start') {
              this.disabled = false
              this.$toast('活动还未开始')
            } else if (res.data.msg == 'end') {
              this.$toast('活动已经结束')
              this.submitBtnText = '活动已经结束'
            } else if (res.data.msg == 'unavailable') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else {
              this.disabled = false
              this.$toast('网络繁忙\n请稍后重试')
            }
            this.submitting = false
          }).catch(() => {
            this.submitting = false
            this.disabled = false
            this.$toast('网络繁忙\n请稍后重试')
          })
      })
    }
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.body {
  padding: 0.8rem;
}
.question {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  text-align: left;
}
.option {
  padding: 0.2rem;
}
</style>
